<script setup>
defineProps({
    value: String,
});
</script>

<template>
    <label class="block font-medium text-sm dark:text-slate-200 leading-120">
        <span v-if="value">{{ value }}</span>
        <span v-else><slot/></span>
    </label>
</template>
